module.exports = __webpack_public_path__ + "img/notification-pending.a3777631.svg";